import { useBizApiClient } from '../request/useBizApiClient';

export const useGenerateToken = () => {
  const [generateToken] = useBizApiClient({
    name: 'generateToken',
    method: 'POST',
    path: '/auth/local/gen_token',
    preventStateResult: true
  });

  return generateToken;
};

export const useEvalToken = () => {
  const [evalToken] = useBizApiClient({
    name: 'evalToken',
    method: 'GET',
    path: '/auth/eval_token',
    preventStateResult: true
  });

  return evalToken;
};

export const useResendVerificationEmail = () => {
  const [resendVerificationEmail] = useBizApiClient({
    name: 'resendVerificationEmail',
    method: 'POST',
    path: '/auth/resend_verification_email',
    preventStateResult: true
  });

  return resendVerificationEmail;
};

export const useSignIn = () => {
  const [signIn] = useBizApiClient({
    name: 'signIn',
    method: 'POST',
    path: '/auth/signin',
    preventStateResult: true
  });

  return signIn;
};

export const useSignOut = () => {
  const [signOut] = useBizApiClient({
    name: 'signOut',
    method: 'POST',
    path: '/auth/signout',
    preventStateResult: true
  });

  return signOut;
};

export const useChangeEmailAddress = () => {
  const [changeEmailAddress] = useBizApiClient({
    name: 'changeEmailAddress',
    method: 'POST',
    path: '/auth/change_email_address',
    preventStateResult: true
  });

  return changeEmailAddress;
};

export const useTestAuth = () => {
  const [testAuth] = useBizApiClient({
    name: 'testAuth',
    method: 'GET',
    path: '/auth/test',
    preventStateResult: true
  });

  return testAuth;
};

export const useWhoami = () => {
  const [whoami] = useBizApiClient({
    name: 'whoami',
    method: 'GET',
    path: '/auth/whoami',
    preventStateResult: true
  });

  return whoami;
};

export const useAcknowledgeTerms = () => {
  const [acknowledgeTerms] = useBizApiClient({
    name: 'acknowledgeTerms',
    method: 'POST',
    path: '/auth/acknowledge_terms',
    preventStateResult: true
  });

  return acknowledgeTerms;
};

export const useAuth = () => {
  const generateToken = useGenerateToken();
  const signIn = useSignIn();
  const signOut = useSignOut();

  return {
    generateToken,
    signIn,
    signOut
  };
};

